
async function fetchLowestPrice(variantId) {
  try {
    const response = await fetch(`/omnibus/variant/${variantId}`);
    const data = await response.json();

    if (data && data.min_price_last_30_days && data.date_of_min) {
      const container = document.createElement("div");
      container.style.fontSize = "14px";
      container.style.marginTop = "10px";
      container.innerHTML = `🛈 Prezzo più basso degli ultimi 30 giorni: <strong>€${data.min_price_last_30_days}</strong> (registrato il ${data.date_of_min})`;

      const priceContainer = document.querySelector(".price, .product__price, .product-price");
      if (priceContainer) {
        priceContainer.parentNode.insertBefore(container, priceContainer.nextSibling);
      } else {
        document.body.appendChild(container); // fallback
      }
    } else {
      console.warn("❌ Nessun dato disponibile per il prezzo minimo.");
    }
  } catch (error) {
    console.error("Errore nel recupero del prezzo minimo:", error);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const variantId = ShopifyAnalytics?.meta?.selectedVariantId || window.meta?.product?.variantId;
  if (variantId) {
    fetchLowestPrice(variantId);
  } else {
    console.warn("❌ ID prodotto o variante non disponibile.");
  }
});
